<si-about
  appName="Gridscale X™ PSS®E Copilot"
  icon="assets/logo.ico"
  [aboutTitle]="'NAV.ABOUT' | translate"
  [licenseInfo]="licenseInfo"
  [subheading]="subheading"
  [imprintLink]="imprintLink"
  [privacyLink]="privacyLink"
  [termsLink]="termsLink"
  [links]="readmeOssLinks"
/>

<ng-template #readmeOssTpl>
  <div class="modal-header">
    <h4 class="modal-title">Readme OSS</h4>
  </div>
  <div class="modal-body p-0">
    <iframe
      #iframeEl
      [src]="readmeOssUrl"
      title="Open Source Software Readme"
      class="readme-iframe"
      sandbox="allow-same-origin"
      referrerpolicy="no-referrer"
      (load)="onIframeLoad(iframeEl)"
    ></iframe>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeReadmeModal()">OK</button>
  </div>
</ng-template>

<ng-template #legalTpl>
  <div class="modal-header">
    <h4 class="modal-title">{{ legalModalTitle }}</h4>
  </div>
  <div class="modal-body p-0">
    <iframe
      #iframeLegalEl
      [src]="legalModalUrl"
      [title]="legalModalTitle"
      class="readme-iframe legal-iframe"
      sandbox="allow-same-origin"
      referrerpolicy="no-referrer"
      (load)="onIframeLoad(iframeLegalEl)"
    ></iframe>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeReadmeModal()">OK</button>
  </div>
</ng-template>
